import React from 'react';

export interface KpiSubItem {
  label?: string;
  value: React.ReactNode;
  isBold?: boolean;
}

export type KpiSubItemInput = string | React.ReactNode | KpiSubItem;

export interface InstitutionalKpiCardProps {
  title: string;
  value: string | React.ReactNode;
  badge?: string;
  badgeBg?: string;
  badgeColor?: string;
  valueColor?: string;
  valueStyle?: React.CSSProperties;
  valueVariant?: 'default' | 'pos' | 'neg';
  subItems?: KpiSubItemInput[];
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
}

export const InstitutionalKpiCard: React.FC<InstitutionalKpiCardProps> = ({
  title,
  value,
  badge,
  badgeBg,
  badgeColor,
  valueColor,
  valueStyle,
  valueVariant = 'default',
  subItems,
  onClick,
  className = '',
  children,
}) => {
  const valueClass =
    valueVariant === 'pos'
      ? 'ns-inst-kpi-card__val--pos ns-mf-kpi-card__val--pos'
      : valueVariant === 'neg'
      ? 'ns-inst-kpi-card__val--neg ns-mf-kpi-card__val--neg'
      : '';

  const combinedValueStyle: React.CSSProperties = {
    ...(valueColor ? { color: valueColor } : {}),
    ...(valueStyle || {}),
  };

  return (
    <div
      className={`ns-inst-kpi-card ${onClick ? 'is-clickable' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="ns-inst-kpi-card__header ns-mf-kpi-card__header">
        <span className="ns-inst-kpi-card__title ns-mf-kpi-card__title">{title}</span>
        {badge && (
          <span
            className="ns-inst-kpi-card__badge ns-mf-kpi-card__badge"
            style={{
              background: badgeBg,
              color: badgeColor,
            }}
          >
            {badge}
          </span>
        )}
      </div>

      <div
        className={`ns-inst-kpi-card__val ns-mf-kpi-card__val ${valueClass}`}
        style={Object.keys(combinedValueStyle).length > 0 ? combinedValueStyle : undefined}
      >
        {value}
      </div>

      {children}

      {subItems && subItems.length > 0 && (
        <div className="ns-inst-kpi-card__sub ns-mf-kpi-card__sub">
          {subItems.map((item, idx) => {
            if (item && typeof item === 'object' && 'value' in item && !React.isValidElement(item)) {
              const kpiItem = item as KpiSubItem;
              return (
                <span
                  key={idx}
                  style={kpiItem.isBold ? { fontWeight: 600 } : undefined}
                >
                  {kpiItem.label ? `${kpiItem.label}: ` : ''}
                  {kpiItem.value}
                </span>
              );
            }
            return (
              <span key={idx}>
                {item as React.ReactNode}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default InstitutionalKpiCard;
